export default __webpack_public_path__ + "static/media/bitcoin.1423a59d.svg";